import React from "react";
import cx from "classnames";
import "./DashboardTile.scss";

interface DashboardTileProps {
  children?: React.ReactNode;
  experimental?: boolean;
  padding?: string;
  extra?: string[];
  right?: React.ReactNode;
}

interface LinkProps {
  url: string;
  icon?: string;
  text: string;
  experimental?: boolean;
  logMetrics?: boolean;
  extraMetricsData?: string;
}

interface FooterProps {
  children: React.ReactNode;
}

const DashboardTile = ({
  children,
  experimental = false,
  padding = "py-3",
  extra,
}: DashboardTileProps) => {
  return (
    <div
      className={
        experimental
          ? cx("card", "clearfix", "dashboard-tile", "mt-3", padding, extra)
          : "card clearfix"
      }
    >
      {children}
    </div>
  );
};

DashboardTile.Title = ({ right, children }: DashboardTileProps) => (
  <div className="card-header">
    <h4 className="float-left">{children}</h4>
    {right && <span className="float-right">{right}</span>}
  </div>
);
DashboardTile.Body = ({ children }: DashboardTileProps) => (
  <div className="card-body">{children}</div>
);

DashboardTile.Footer = ({ children }: FooterProps) => {
  return <div className="card-footer">{children}</div>;
};
DashboardTile.Link = ({
  url,
  icon,
  text,
  experimental,
  logMetrics = false,
  extraMetricsData,
}: LinkProps) => {
  return experimental ? (
    <DashboardTile.Footer>
      <a
        href={url}
        className={logMetrics ? "js-log-metric" : ""}
        {...(extraMetricsData
          ? {
              "data-metrics_category": "dashboard_links",
              "data-metrics_sub_category": extraMetricsData,
            }
          : {})}
      >
        <button className="btn btn-xl btn-primary">
          {icon && <i className={`far fa-${icon} pr-2`} />}
          {text}
        </button>
      </a>
    </DashboardTile.Footer>
  ) : (
    <div className="card-footer p-4 text-right">
      <a
        href={url}
        className={"btn btn-lg btn-xl btn-outline-smoke " + (logMetrics ? "js-log-metric" : "")}
        {...(extraMetricsData
          ? {
              "data-metrics_category": "dashboard_links",
              "data-metrics_sub_category": extraMetricsData,
            }
          : {})}
      >
        <i className={`far fa-${icon} pr-2`} />
        {text}
      </a>
    </div>
  );
};

export default DashboardTile;
